var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"commenting-badge",class:{
    'commenting-badge--is-new': _vm.type === 'new',
    'commenting-badge--is-unseen': _vm.type === 'unseen',
  },attrs:{"data-cy":("comment-badge-" + _vm.type),"ripple":false,"x-small":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }